var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _polygon, _rect20, _rect21, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalk2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    fill: "#1c1530"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 88,
    width: 52,
    height: 14,
    fill: "#3a2458"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 88,
    width: 52,
    height: 2,
    fill: "#c09840",
    opacity: 0.55
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 74,
    width: 14,
    height: 14,
    fill: "#2d1e48"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 74,
    width: 52,
    height: 14,
    fill: "#3a2458"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 74,
    width: 52,
    height: 2,
    fill: "#c09840",
    opacity: 0.55
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 60,
    width: 14,
    height: 14,
    fill: "#2d1e48"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 60,
    width: 52,
    height: 14,
    fill: "#3a2458"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 60,
    width: 52,
    height: 2,
    fill: "#c09840",
    opacity: 0.55
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 46,
    width: 14,
    height: 14,
    fill: "#2d1e48"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 46,
    width: 52,
    height: 14,
    fill: "#3a2458"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 46,
    width: 52,
    height: 2,
    fill: "#c09840",
    opacity: 0.55
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 32,
    width: 14,
    height: 14,
    fill: "#2d1e48"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 24,
    width: 24,
    height: 8,
    fill: "#3a2458"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 24,
    width: 24,
    height: 2,
    fill: "#c09840",
    opacity: 0.55
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 76,
    width: 2,
    height: 12,
    fill: "#5ab4ac",
    opacity: 0.35
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 62,
    width: 2,
    height: 12,
    fill: "#5ab4ac",
    opacity: 0.35
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 48,
    width: 2,
    height: 12,
    fill: "#5ab4ac",
    opacity: 0.35
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 34,
    width: 2,
    height: 12,
    fill: "#5ab4ac",
    opacity: 0.35
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "24,22 28,10 32,22",
    fill: "#c09840",
    opacity: 0.8
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 8,
    width: 6,
    height: 6,
    fill: "#c05848",
    opacity: 0.65,
    transform: "rotate(45 151 11)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 108,
    width: 6,
    height: 6,
    fill: "#5ab4ac",
    opacity: 0.45,
    transform: "rotate(45 9 111)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 20,
    r: 1.5,
    fill: "#f0e0c8",
    opacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 12,
    r: 1,
    fill: "#f0e0c8",
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 36,
    r: 1,
    fill: "#f0e0c8",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk2);
export default __webpack_public_path__ + "static/media/talk2.e6fca6ad42a358ee43c0809d82c60260.svg";
export { ForwardRef as ReactComponent };